import select from './SearchDictItemSelect.vue'
const ZPGLSearchDictItemSelect = {
  install: function (Vue) {
    Vue.component('ZPGLSearchDictItemSelect', select)
  }
}
export default ZPGLSearchDictItemSelect
